export default __webpack_public_path__ + "static/media/screenBlock23.16f2595b.jpg";